export default {"src":"/_next/static/media/no-result-not-pay.6215ef21.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};